import * as React from "react";
import Layout from "./layout";
export default class View extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(Layout, null));
    }
}
;
//# sourceMappingURL=view.js.map